import { render } from "./HospitalDashboard.vue?vue&type=template&id=2939875a&ts=true"
import script from "./HospitalDashboard.vue?vue&type=script&lang=ts"
export * from "./HospitalDashboard.vue?vue&type=script&lang=ts"

import "./HospitalDashboard.vue?vue&type=style&index=0&id=2939875a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__